// extracted by mini-css-extract-plugin
export default {"adaptiveContainer":"AdaptiveBlock_adaptiveContainer__HJMkc","container":"AdaptiveBlock_container__R2djW","errorText":"AdaptiveBlock_errorText__zsRXC"};